import { render, staticRenderFns } from "./AirWallexBtn.vue?vue&type=template&id=ff205eb2&scoped=true&"
import script from "./AirWallexBtn.vue?vue&type=script&lang=js&"
export * from "./AirWallexBtn.vue?vue&type=script&lang=js&"
import style0 from "./AirWallexBtn.vue?vue&type=style&index=0&id=ff205eb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff205eb2",
  null
  
)

export default component.exports